import { isInArray, Lookup } from 'hevy-shared';

const _onboardingScreens = ['verification', 'username', 'units', 'plans', 'finish'] as const;
export type OnboardingScreenName = Lookup<typeof _onboardingScreens>;
export const isOnboardingScreenName = (x: unknown): x is OnboardingScreenName =>
  isInArray(x, _onboardingScreens);
